// EN
export const locale = {
  MESSAGE: {
    OUTOFPOLICY: "OUT OF POLICY",
    INPOLICY: "IN POLICY",
    CONFIRMBUTTONTEXT: "OK",
    CONFIRMCANCELTEXT: "No",
    PLEASEINPUT: "Please Input",
    PLEASESELECT: "Please Select",
    SAVE: "Save",
    CONFIRMBTN: "Confirm",
    RESETBTN: "Reset",
    DOWNLOADSTART: "Start downloading...",
  },
  ERRORMESSAGE: {
    500: "The network is unstable, please try again later!",
    400: "There is an error, please try again later!",
    403: "Your operation is not supported!",
    404: "The resource doesn't exist!",
    40001: "Lacking of your personal information, please update your profile before your next booking.",
    10001: "The network is unstable, please try again later!",
    10002: "The network is unstable, please try again later!",
    10003: "The network is unstable, please try again later!",
    10004: "The resource doesn't exist!",
    10005: "The resource doesn't exist!",
    10006: "Your operation is not supported!",
    10007: "The resource doesn't exist!",
    10008: "The network is unstable, please try again later!",
    10009: "Connection timed out. Please try again later!",
    10099: "There is no qualified travel slip!",
    10101: "Sorry there are no available hotels.",
    10201: "Sorry, there is no available rooms and prices!",
    10301: "The hotel resource doesn't exist!",
    10401: "This hotel is sold out, please change to another hotel!",
    10501: "Fail to update the order, please try again later!",
    10601: "Sorry, there is no available hotel order!",
    10701: "The order does not exist!",
    10702: "You cannot access to this order!",
    10703: "Searching failed, please try again later!",
    10801: "Sorry this room is not available please choose another room!",
    10802: "The network is unstable, please try again later!",
    10803: "Sorry, this price type is not available, please select others!",
    10804: "please try again later or contact CWT Service Team!",
    10805:
      "Sorry the price has been changed, please try it again or contact CWT Service Team!",
    10806:
      "Sorry the reservation has failed, please try again later or contact CWT Service Team!",
    10807: "Reservation has failed!",
    10810:
      "The company account balance is insufficient. Please recharge and try to book again!",
    10901: "Sorry this room is not available please choose another room!",
    10902:
      "Sorry the price has been changed. Original Price: ¥{oldprice}, New Price: ¥{newprice}",
    10903: "",
    11101:
      "The company account balance is insufficient. Please recharge and try to book again!",
    11201:
      "Your order cannot be cancelled, please contact the CWT service team!",
    11301: "Order “{OrderNo}” has now been attached into Big Order “{ItineraryOrder}”",
    11302: "Please select the Order Number to attach to the Big Order.",
    11303:
      "You must select an order created by the same person in the same enterprise!",
    11304: "Attachment Successful!",
    11305: "Move in failed! Please try again later!",
    13001: "The number of orders exceeded the limit and the download failed!",
    90000: "Error in payment!",
    90001: "Error in payment please provide correct payment information to proceed!",
    90002: "Current booking cannot be paid or no need to pay!",
    91001: "Wrong security code, please enter again!",
    91002: "code expired",
    NOTFOUND: "Please try again later!",
    BOOKINGFAILED: "Sorry, your order reservation has failed, ",
    ORDER500: "Sorry, your order reservation has failed, please try again later or contact CWT Service Team!",
    ORDER501: "Please try again after 10 mins in case duplicated order generated.",
  },
  BREADCRUMB: {
    BOOKING1: "Booking Confirmation Page",
    BOOKING2: "Order Details Page",
    ORDERMANAGE: "Order Management",
    ORDERLIST: "Order List",
    ORDERDETAIL: "Order Detail",
    MYORDER: "My Order",
    GUARANTEE: "Booking Payment Page",
  },
  DATEPICKER: {
    FIRSTLABLE: "Check In",
    LASTLABLE: "Check Out",
    NIGHT: " night (s)",
    CHECKIN: "In",
    CHECKOUT: "Out",
    MCHECKIN: "In",
    MCHECKOUT: "Out",
  },
  SEARCH: {
    DESTINATION: "Destination",
    GUESTS: "Guests",
    KEYWORDS: "Keywords",
    ADDRESSSEARCH: "Address Search (Street, building name)",
    ADDRESSNOTFOUND: "Sorry, we can't locate this adress.",
    NOTMATCH:"Sorry, the location does not match the city you searched. Please update the city and try again.",
    APPROVED: "Itinerary",
    CONFIRMDES: "Please choose a destination, then to search hotels!",
    CONFIRMCHECK: "Please choose the Check-In and Check-Out Date first!",
    CONFIRMRANGEIN:
      "The CheckIn Date out of the range between the {inDate} and {outDate}, please choose another CheckIn Date.",
    CONFIRMRANGEOUT:
      "The CheckOutDate out of the range between the {inDate} and {outDate}, please choose another CheckOut Date.",
    INVALID_CHECKIN_OR_CHECKOUT_DATE: "The selected CheckIn or CheckOut Date does not meet the approval requirements. Please check and choose another date.",
    CHECKINOUTDATE:
      "According to the hotel reservation rules, you can book rooms for up to {maxDay} continuous nights. The booking period has exceeded the limit. Please verify your check-in and check-out dates.",
    CONFIRMDEST:
      "The currently selected destination is inconsistent with the trip destination",
    CONFIRMTRIP: "No select trip order or this trip order has expired",
    CHECKINOUTDATE2: "Cannot choose the same check-in time and check-out time",
    CURRENCYTITLE: "Currency switching",
    DOMESTICAPPROVED: "Please choose a domestic city from the approved trips to book a hotel!",
    ABROADAPPROVED: "Please choose an international city from the approved trips to book a hotel!",
  },
  HEADER: {
    NAV1: "Domestic Flight",
    NAV2: "International Air",
    NAV3: "China Hotels",
    NAV4: "Train Tickets",
    NAV5: "Car Rental",
    NAV6: "Visa",
    BARITEM1: "Welcome {msg}",
    OBTNAV1: "Antiepidemic Tool",
    OBTNAV2: "Pending Disposal ({number})",
    OBTNAV3: "Order Management",
    OBTNAV4: "Customer Service",
    OBTNAV5: "Log Out",
    FL01: "Home",
    FL02: "Domestic Flight",
    FL03: "International Air",
    FL04: "China Hotels",
    FL05: "Trains",
    FL06: "Exit Visa",
    FL07: "Chauffeurs",
    FL10: "International Hotels",
    INTLPHONE: "Intl: {intlPhone}",
    CONTACTNUM: "Contact Number: {CONNUM}",
    CONTACTMAIL: "Contact E-mail: {CONMAIL}",
  },
  FOOTER: {
    MES1: "Copyright &copy; 2022 CWT, all rights reserved{copyLink}Technical assistance",
    MES2: "We are committed to protecting your personal data and privacy. Read CWT's {privacyLink} , understand the information collected by CWT and the reason for collection, as well as CWT",
    MES3: "How to use and store this information. Please read our {cookieLink} To select your cookie preferences. For more information, see {termsLink}.",
    PRIVACY_LINK: "Global Privacy Policy and Notices",
    COOKIE_LINK: "Cookie Policy",
    TERMS_LINK: "Terms of Use"
  },
  HOME: {
    TITLE: "Hotel inquiry",
    BUTTONSEARCH: "Search",
    ONLYSEARCH:"Search Only",
    BUTTONMAP: "Go To Map",
    NOTES: "Notice:",
    // NOTES1: "Credit card guarantees may be subject to pre-authorization;",
    // NOTES2:
    //   "Using a foreign currency card for pre-authorization will result in handling charges and exchange rate differences.",
    // NOTES3:
    //   "If it is failed to make guarantee, the problem is usually that dual-currency credit cards and credit cards issued abroad are not available for some hotel resources, please use another credit card.",
    NOTRIPSTIPS: "No business trip approval form has been queried",
    TRIPSERROR: "Travel order information request failed",
    TRIPSSELECTTIPS:
      "Sorry, there is no approved trips. Please ensure the approvals have been obtained prior to booking hotels.",
    RESPONSEDATA: {
      notice: "en",
    },
    JUDGECTCITYTITLE: "This region has been blocked for booking.",
  },
  RESULT: {
    PRICETYPECHANGE: "Approx.",
    CURRENCY: "Currency Exchanged",
    USD: "USD",
    EUR: "EUR",
    CNY: "CNY",
    RESPONSEDATA: {
      name: "en",
      address: "en",
      locationNameLists: "en",
    },
    MAP: "Map",
    RESULT: "Result",
    OUTOFPOLICYTIPEMPTY: "Price/StarRate Out of Policy",
    OUTOFPOLICYTIP1: "Your price upper limit is {price}",
    OUTOFPOLICYTIP2: "Your Star Rating upper limit is {star} stars",
    OUTOFPOLICYTIP3: "Not complied pricing type",
    OUTOFPOLICYTIPAdd: "You cannot proceed on the online booking since {outOfPolicy}.  Please turn to service team for help if needed.",
    DESTINATION: "Destination",
    GUESTS: "Guests",
    KEYWORDS: "Keywords",
    DISTRICT: "District",
    AIRORTRAIWAY: "Airport/Railway Stations",
    CUSTOM: "Company Locations",
    TOTAL: "Total:",
    HOTELSFOUND: "Hotels",
    CLEAR: "CLEAR",
    CURRENTLOCATION: "Current Location:",
    SEARCH: "SEARCH",
    PRICE: "Price",
    PRICERANGE:"Price Range",
    STARRATING: "Star Rating",
    DISTANCE: "Distance",
    SHOWONMAP: "Show on Map",
    TEL: "TEL:",
    ADDRESS: "Address:",
    CORPORATEPAYMENT: "Company Pay",
    CONTRACTEDHOTEL: "Company Preferred",
    CHAIMWIDE: "Company Preferred Hotel Chain",
    CWTHOTEL: "CWT Negotiated Price",
    ABOVE: "from",
    CHECKAVAILABILITY: "SELECT ROOM",
    SHOWMORE: "Show More",
    NOMORE: "No Additional Hotels Available",
    NOMOREWARNING:
      "Sorry, we didn't find any hotels that match your search criteria!",
    SEARCHHOTEL: "Search Page",
    LISTSEARCHHOTEL: "Hotel Results Page",
    LOCATION: "Location",
    PAYMENT: "Payment Method",
    ESTIMATEDPRICE: "Estimated Price",
    MOBILELOCATION: "Filter",
    MOBILESORT: "Sort",
    MOBILESORTPRICEHIGH: "Price (High to Low)",
    MOBILESORTPRICELOW: "Price (Low to High)",
    MOBILESORTSTARHIGH: "Star (High to Low)",
    MOBILESORTSTARLOW: "Star (Low to High)",
    MOBILESELECTAIR: "Please select an airport/train station!",
    MOBILESELECTCUSTOMER: "Please select custom coordinates!",
    PRICERANGE1: "unlimited",
    PRICERANGE2: "0-300",
    PRICERANGE3: "300-500",
    PRICERANGE4: "500-1000",
    PRICERANGE5: "From 1000",
    PRICERANGE6: "customize",
    PRICERANGE7: "From {priceRange}",
    HOTHOTEL:"Hot Hotel",
    MOBILESELECTHOTHOTEL: "Please select Hot Hotel!",
    STARSELECT:"Star Rating",
    STAR1:"1 Star",
    STAR2:"2 Star",
    STAR3:"3 Star",
    STAR4:"4 Star",
    STAR5:"5 Star",
    EMISSION: "ECO-FRIENDLY",
    Separator: "| ",
    EMISSIONTIP: "Emissions are calculated per room using 3rd party methodology and consider location, hotel chain and star rating.",
  },
  DETAIL: {
    TAXIN: "incl. tax",
    TAX: "TAX：",
    OTHERS: "Others：",
    TOTALTAXES: "Total taxes",
    TOTALFEES: "Total fees",
    AVGNIGHTLYRATE: "Avg Nightly Rate",
    RESPONSEDATA: {
      bedtype: "en",
      facility: "en",
    },
    HOME: "Search Page",
    HOTELRESULT: "Hotel Results Page",
    DETAILPAGE: "Hotel Details Page",
    BTN1: "Select Room",
    BTN2: "BOOK",
    BTNCWTBUR: "APPLY",
    MSG1: "Airport pickup service | Front desk (24 hours) | Meeting Room",
    MSG2: "View All Facilities",
    ABOVE: "From",
    ROOMTYPE: "Room Type",
    DESCRIPTION: "Description",
    FACILITIES: "Facilities",
    POLICIES: "Policies",
    SLEEPS: "Adults per Room",
    BEDTYPE: "Bed Type",
    BREAKFAST: "Breakfast",
    HASBREAKFAST: "With Breakfast",
    FACILITES: "Window",
    POLICY: "Policy",
    RATE: "Rate(After Tax)",
    PAYMENTTYPE: "Payment Type",
    TITLE1: "About JW Marriott Hotel",
    TITLE2: "Facilities",
    TITLE3: "Hotel Policies",
    TITLE4: "Carbon emissions estimate",
    CO2:"‌CO₂‌e",
    CARBON_EMISSIONS: {
      NIGHTLY: "Carbon Footprint for 1 night - {carbonFootprint}KG CO₂e.",
      TOTAL: "Total Carbon Footprint for your stay - {totalCarbonFootprint}KG CO₂e.",
      DESCRIPTION: "Emissions are calculated per room using 3rd party methodology and consider location, hotel chain and star rating."
    },
    CONTENTTITLE:
      "Non-Refundable/Free Cancellation/Cancellation with Time Limit",
    POLICYTITLE: "Cancelation Policy:",
    GUARANTEERULES:
      "1.Free Cancellation before【2021-12-02 00:00】.<br>2.Time Limited Cancellation, deduction rate: full payment.<br>3.Cancellation fee:300CNY.<br>4.Overtime Cancellation, deduction rate: one night amount.",
    CONTENTTITLE2: "All Guarantee/First Night Guarantee",
    NOTESTITLE: "Guarantee Policy:",
    NOTESTCON:
      "You need to provide credit card guarantee. If you do not check in on time on the day of arrival; Full security will be charged as a default fee.",
    CONDITIONS: "Booking Conditions:",
    // CONDITIONSCONTENT:
    //   "1.Not Available for Foreign Guests.<br>2.Earliest Check-In Time: 2021-12-02 14:00, Latest Check-Out Time: 2021-12-03 12:00.",
    CHECKINTIME: "Earliest Check-In Time:",
    CHECKOUTTIME: "Latest Check-Out Time: ",
    FOREIGNGUESTS1: "This hotel only available to Chinese guests.",
    FOREIGNGUESTS2:
      "This hotel is available to both Chinese and foreign guests.",
    PAYMENTTYPE1: "Pay At Hotel",
    PAYMENTTYPE2: "Online Pay",
    PAYMENTTYPE3: "Company Pay",
    INSTANT: "Instant Confirmation",
    DELAY: "Delay Confirmation",
    NEGOTIATEDPRICE: "Negotiated Price",
    GUARANTEE: "Guarantee",
    DEPOSIT: "Deposit",
    PREPAYMENT: "Prepayment",
    DIALOGIMAGETITLE: "Hotel Photos",
    PROPERTYINFO: "Room Info",
    VIEW: "View",

    linshi1: "1 queen bed",
    linshi2: "No Breakfast",
    linshi4: "¥300",
    linshi5: "Free WiFi",
    linshi6: "NO WIFI",

    HOTELDEATIL:
      "Opened:2011 Combining the history and culture of the celebrated",
    HOTELLISTROOM: "Grand Queen Bed",
    HOTELLISTWINDOW: "window",
    HOTELDETAILFOOTER1:
      "JW Marriott Hotel located in the center of JingAn area, which has the most convenient subway station Jing An Temple station. From Jing An Temple station，you may take subway line 2 directly both to Pudong and Hong Qiao Airtports/ Railway station.",
    HOTELDETAILFOOTER2:
      "As for the surrounding of hotel itself, there are lounge bars, dance floor, all kinds of asian and western restaurants. Though in the center area of Shanghai, you can still experience the local life just around the corner, with local farmers market or small stall of street foods.",
    HOTELDETAILFOOTER3: "",
    HOTELDETAILFOOTER4: "",
    HOTELFAC1: "Wi-Fi in designated areas",
    HOTELFAC2: "Bathrooms",
    HOTELFAC3: "Paid parking service",
    HOTELFAC4: "Airport pickup service",
    HOTELFAC5: "Luggage storage Free",
    HOTELFAC6: "Call taix service",
    HOTELFAC7: "Beverage service",
    HOTELFAC8: "Front desk(24 hours)",
    CWTPRICE: "CWT Negotiated Price",
    CLIENTPRICE: "Company Negotiated Price",
    NA: "N/A",
    PRICECHANGED: "Sorry, the price has been changed.",
    ORGPRICE: "Original Price:",
    NEWPRICE: "New Price:",
    EXCEEDEDPRICE: "Your price upper limit is",
    EXCEEDEDPSTAR: "Your Star Rating upper limit is",
    SYMBOL1: "stars",
    SYMBOL2: "",
    SERVER1: "Front Desk",
    SERVER2: "Restaurant",
    SERVER3: "Infrastructure",
    SERVER4: "Entertainment",
    SERVER5: "Others",
    NOMORETITLE: "Sorry, there is no available rooms and prices!",
    CANCELLATIONPOLICY0: "Non-Refundable",
    CANCELLATIONPOLICY1: "Free Cancellation",
    CANCELLATIONPOLICY2: "Cancel with Time Limit",
    MOREINFO: "more",
    SHOWONMAP: "Map",
    SEPARATOR: "|",
    GUEST: "1 guest | {bedCount} guests",
    ChainwidePrice: "-Chainwide",
    LoyaltyPoints: "Loyalty Points",
    NoLoyaltyPoints: "NO Loyalty Points",
    DECORATEDAT:"Renovation Year : {decoratedAt}",
    OPENEDAT:"Opening Year : {openedAt}",
    SearchNearbyHotels:"Search nearby hotels",
    BestPrice:"Best Price",
    CannotBeCanceled:"You have selected a Non-Refundable Rate Plan. Please confirm if you would like to proceed with the booking."
  },
  BOOKING: {
    BOOKING: "Booking Details Page",
    MESSAGEPROMEPT: "Please review the booking details in below:",
    HOTELTITEL: "JW Marriott Hotel Shanghai at Tomorrow Square",
    HOTELADDRESS: "No.29 East 3rd Ring North Road",
    ROOMTYPE: "Room Type:",
    KINGBEDGUESTROOM: "KING BED GUEST ROOM",
    DESCRIPTION: "Room Description:",
    ROOMDESCRIPTION: "Located on the {floor}(th) floors",
    ROOMDESCRIPTIONAREA: "Room Size: {area}",
    BREAKFAST: "Breakfast:",
    RATEPLANDES: "Booking Type:",
    BOOKINGCONDITIONS: "Booking Conditions:",
    INSTANTCON: "Instant confirmation",
    FOREIGNTRAVEL: "Not available to foreign guests",
    FOREIGNTRAVELTRUE: "Available to foreign guests",
    CHECKININFO: "Booking Information",
    CHECKININFOMSG:
      "Please ensure booked information is as per your valid travel documents",
    TITLE: "Guest Information",
    OTHERTITLE: "Other Guest Information",
    OTHERTITLEPROMPT: "Please inform the hotel staff your conforamtion number or primary guest name to find your booking upon check-in.",
    OTHERTITLEREPORT: "Please don't enter same guests information!",
    COLNAME: "Name",
    COLTELEPHONE: "Mobile",
    NATIONALITY: "Nationality",
    GENDER: "Gender",
    EMAIL: "Email",
    MEMBERSHIP: "Membership Card",
    SPECIAL: "Custom",
    SPECIALINFO:
      "For preferences/special request for your stay, this is subject to hotel availability and are at the hotel's sole discretion.",
    SPECIALALERT:
      "We suggest that you contact the hotel if the hotel does not require a guarantee and your arrival time is later than otherwise stated.",
    SPECIALALERT1:"Your order will be paid in advance by CWT, hotel may hold room or incidental charges upon check-in. Your deposit will be returned on the check out day. You will be responsible for other incidental expense during your stay.",
    SPECIALALERT2:" Late Check-in after 18:00 will need a guarantee for this order in case order being cancelled by hotel. Pls input accurate check-in time here!",
    SPECIALALERT3:"Please contact the hotel to ensure the room can be kept for arrival after 24:00 in case this order being cancelled as a no-show with a penalty charge by hotel.",
    SPECIALALERT4:"Please guarantee your booking by using international credit card in case booking being cancelled by hotel. ",
    AVGPRICE: "Avg. Amount",
    TOTALPRICE: "Room Fee",
    PRICELINK: "Click to view the price detail",
    POLICIES: "Non-Refundable/Fee Cancellation/Cancellation with Time Limit",
    POLICIES1: "Non-Refundable",
    POLICIES2: "Fee Cancellation",
    POLICIES3: "Cancellation with Time Limit",
    POLICIES4: "Non-Changeable",
    ALLGUARANTEE1: "All Guarantee",
    ALLGUARANTEE2: "First Night Guarantee",
    ALLGUARANTEE3: "No Guarantee Required",
    ALLGUARANTEE5: "Deposit",
    ALLGUARANTEEFEE: "Guarantee policy: First night guarantee or all night guarantee based on the hotel cancellation policy",
    ALLGUARANTEEFEE2: "Guarantee policy: You might be charged after your booking is confirmed for the first night deposit or the total price based on the hotel guarantee policy.",
    GUARANTEE: "Guarantee Policy:",
    NOTES: "Cancellation Policy:",
    CHECKNOTES:
      "I have read the above and agree to the terms and conditions. I am aware that I shall bear the guarantee fee.",
    SUBMIT: "SUBMIT",
    EMPLOYEEID: "Employee ID",
    COSTCENTER: "Cost Center",
    CHOOSENTYPE: "Please choose payment type",
    COMPANYPAY: "Company Pay",
    PAYATHOTEL: "Pay at Hotel",
    EMPLOYERONE: "employerOne",
    EMPLOYERTWO: "employerTwo",
    EMPLOYERTHREE: "employerThree",
    BEDTYPE: "Bed Type",
    NOSMOKING: "No Smoking",
    ARRIVALTIME: "The Latest Arrival Time",
    POLICY1: "Free cancellation before [{0}].",
    POLICY2: "Cancellation Fee after the time limit/no-show fee: Fee of the first night stay or all night stay based on the hotel cancellation policy.",
    GUARANTEEDES_PART1: "You may need to provide a credit card requested by the hotel to guarantee the booking. Your card data will be processed in accordance with our data privacy policy: [",
    GUARANTEEDES_LINK: "https://www.mycwt.com/legal/global-privacy-policy/",
    GUARANTEEDES_PART2: "]. Your data will be shared with the hotel and other authorized hotel suppliers for the booking. If the hotel is outside China, your data will be transferred outside China. Your booking cannot be processed without your agreement to these terms. If you do not cancel within time limit or fail to show the guarantee fee will be deducted (forfeited) from the credit card by the hotel.",
    PAYMENTTYPE: "Payment Type",
    LATESTARRIVALT: "Latest Arrival Time",
    DYNAMICALLY1: "Read Data1 Dynamically",
    DYNAMICALLY2: "Read Data2 Dynamically",
    SPECIALREQ: "Special Requests (Optional)",
    SPECIALROOM: "Room Special Requests (Optional)",
    SPECIALBED: "Bed Special Requests (Optional)",
    OPTION: "Your requests will be passed on to hotel but cannot be guranteed.",
    BREAKFASTNUM: "Breakfast x {num}",
    NOBREAKFAST: "No breakfast",
    BREAKFAST99: "Breakfast",
    BREAKFASTUNKNOWN: "Unknown",
    VALIDATEMES1: "Please provide your enter name",
    VALIDATEMES2: "Please provide your phone number",
    VALIDATEMES3: "Please provide your email",
    VALIDATEMES4: "Please provide your payment type",
    VALIDATEMES5: "Please provide your latest arrival time",
    PHONEVA: "Please provide the correct phone number",
    OUTOFPOLICY:
      "You cannot book this room since your reservation has exceeded the standard!",
    OUTOFPOLICY2: "Insufficient inventory, unable to book!",
    PAYMENTTYPE1: "Pay At Hotel",
    PAYMENTTYPE2: "Online Pay",
    PAYMENTTYPE3: "CompanyPay",
    BURTIPS:
      "This order is a delayed confirmation Hotel and needs to be confirmed by the service group during normal working hours. For urgent assistance, please call service team.",
    BURTIPS2:
      " If the system does not confirm the 'Successful' status immediately after booking, you must wait for the Service Team to verify with the hotel during regular service hours. For the reservation of night service time (Monday to Sunday, 18: 00-08: 30), if you are checking -in on the same day, please contact the service team to confirm the booking.",
    BURTIPS3:
      "For immediate confirmation, please call our service team at {customPhone}, emergency service line outside business hours number 400 887 7076.",
    SELECTTRIPS:
      "The guest is not on the white list. According to the company regulations, please select an approved trip to book the hotel",
    GUESTNAMERULE: "Please input name as above: ZHANG/SAN.",
    GUESTNAMERULESABRE: "Please input name as above: ZHANG/SAN.",
    EXCEEDEDPRICE: "Your price upper limit is: {price} ",
    EXCEEDEDPSTAR: "Your Star Rating upper limit is: {star} stars",
    TRIPSELECTGUEST:
      "Sorry, the guest is not on the white list. The destination is different with the approved trip, please change a destination.",
    GUESTSELECTSABRE:
      "Please enter the name in English or Pinyin. please add the guest information!",
    INPUTCARDHOLDER: "Sample: ZHANG/SAN",
    GUARANTEEDES2:
      "The reservation will be guaranteed by the company account. If you did not check in on time, the penalty fee will be charged according to your company's travel policy.",
    VERIFYREPEATORDERTITLE: "You have an existing booking on the same date, please confirm if you would like to make another booking in the period of time.",
    BURBOOKINGTITLE: "* Bookings are usually confirmed by the hotel within 1 hour. ",
    ELONGGUARANTEE: "*The order will be cancelled automatically in 30 minutes unless payment is made.",
    ELONGHINT_LINE2: "*In order to guarantee your reservation, you may need to activate a third-party payment to pay the guarantee. You will need to pay the room fee upon arrival. Guarantee will be refunded within 5 working days of departure.",
    MEMBERSHIPCARD: "Loyalty Card",
    ADDMEMBERSHIPCARD: "Add LoyaltyCard",
    EDITMEMBERSHIPCARD: "Edit LoyaltyCard",
    CHOSEMEMBERSHIPCARD: "Please select LoyaltyCard",
    MEMBERSHIPCARDMSG: "* You can insert your loyalty points number so you won’t miss the chance to collect eligible points. For the T&C of the loyalty plan, please check with the hotel.",
    MEMBERSHIPCARDTRIPS: "Please enter loyalty card number",
    MEMBERSHIPCARDTRIPSRule: "!Max 21 letter&numbers allowed",
    HOTELGROUP:"Hotel Chain",
    ReasonCode:"Reason Code",
    CostCenterTitle1:"Cost center is mandatory for booking. Please select a cost center to continue.",
    CostCenterTitle2:"Cost center is mandatory for booking. Please reach out to relevant dept. to finish cost center setup first. ",
    CostCenterUATPTitle1:"UATP/CTA card are missing. Please reach out to relevant dept. to finish its setup first. ",
    CostCenterUATPTitle2:"Your UATP card expired. Please reach out to relevant dept. to correct the setup first. ",
    CostCenter:"Cost center",
    CostCenterEdit:"Cost center",
    CopyButton:"Copy",
    CopyValidateMsg:"The order cannot be copied owing to the account info changed. Please start your booking from the hotel shopping page.",
    DISCLAIMER:"Pls make sure all the credit card information you provide to guarantee is correct, otherwise the hotel will make the final cancellation after the “booked” order. The final interpretation belongs to the hotel.",
    INTLTAXDISPLAY:"Total room rate may not include service charge and city tax, you may need to pay additional when you checkout.",
    BREAKFASTTITLE:"Breakfast inclusion might be incorrect.",
    Reminder:"Reminder:",
    RoomTypePoints:"The rate selected is loyalty benefit eligible.",
    RoomTypeNoPoints:"The rate selected is not eligible for loyalty benefits.",
    RoomTypeConfirmPoints:"The loyalty benefit eligibility is subject to confirmation by the hotel at the time of check-in.",
    productCode:"Product Code: {productCode}",
    BreakFastAnalysis:"Amenities translation:",
    BreakFastIncludingBreakfast:"breakfast included",
    BreakFastBreakfastExcluded:"breakfast excluded",
    BreakFastAnalysisFailMessage:"How amenities translation works:\nWe have uploaded a complete English description of the pricing plan to the machine learning database, which uses keywords to determine whether breakfast is included in the rate. The accuracy rate exceeds 95%, but guests should still confirm whether breakfast is included upon check-in."
  },
  CONFIRMATION: {
    BOOKING: "Booking Confirmation Page",
    CONFIRMED: "Confirmed",
    ORDERNUM: "Order Number:",
    NEEDTOKNOW: "Need to Know",
    NEED1: "Not available to foreign travelers.",
    NEEDNO: "Non-refundable Non-changeable",
    NEEDYES: "Free cancellation",
    NEED2: "Free cancellation before {date}.",
    NEED3ALL:"Full guarantee amount would be deducted if cancelled after {date}.",
    NEED3: "Full guarantee amount would be deducted if cancelled after {date}.",
    NEED5: "Cancellation made after {date} will be subject to a full deposit amount. ",
    NEED6: "This reservation is secured with a virtual card. The hotel may require you to provide a valid credit card or alternative guarantee to confirm your room reservation.",
    TITLE2: "Booking Information",
    TITLE3: "Special Requests",
    TITLE4: "Note Matters",
    TITLE5: "Booking Contact",
    TITLE6: "Service Team Information",
    CHECKINDATE: "Check-In Date",
    CHECKOUTDATE: "Check-Out Date",
    ARRIVALTIME: "The Latest Arrival Time",
    ROOMNUM: "Rooms",
    TRAVLERNAME: "Guest Name",
    MOBILE: "Mobile",
    EMAIL: "Email",
    NIGHT: "Nights",
    EMPLOYEEID: "Employee ID",
    COSTCENTER: "Cost Center",
    NOTEMATTERS1:
      "Total rate may not include the service fee and tax. Please check the rate description for details.",
    NOTEMATTERS2:
      "If you choose China Merchants Bank as the bank of credit card guarantee, you will receive a text message of pre-authorization confirmation later. Please handle it as soon as possible after receiving it.",
    NOTEMATTERS3:
      "Credit card guarantees may be subject to pre-authorization;Using a foreign currency card for pre-authorization will result in handling charges and exchange rate differences.",
    GUESTNUM: "Guests:",
    BEDTYPE: "Bed Type:",
    BREAKFAST: "Breakfast:",
    ROOMSIZE: "Room Size:",
    ORDERINFO: "Order Information",
    BOOKINGDATE: "Booking Date:",
    HOTELTYPE: "Hotel Type:",
    ORDERSTATUS: "Order Status:",
    GUARANTEEINFO: "Guarantee Information",
    PAYMENTTYPE: "Payment Type:",
    // CARDNUM: "Card Number:",
    AVGPRICE: "Avg. Amount:",
    TOTALPRICE: "Total Amount:",
    TOTALROOMPRICE:"Room Fee:",
    BTNCANCEL: "Cancel Order",
    BTNUPDATE: "Update Order",
    BTNCONFIRM: "Confirm Order",
    BTNREJECT: "Reject order",
    BOOKINGNAME: "Booking Name",
    MOBILEPHONE: "Mobile",
    BOOKINFOEMAIL: "Email",
    TCNAME: "Name",
    TCTEL: "Tel",
    TCEMAIL: "Email",
    TCFAX: "Fax",
    PRICETYPE: "Price Type:",
    TRAVELPOLICY: "Travel Policy:",
    CONFIRMMSG: "Do you Confirm the Cancellation of the order?",
    CONFIRMREJECT: "Reject this order?",
    PRICELINK: "Click to view the price detail",
    REFRESHCONTENT:
      "Sorry, this room has been sold out, <br>please choose another room.",
    REFRESHBTN: "REFRESH",
    CANCLEBTN: "CANCEL",
    PROCEED: "Proceed",
    BEDTYPE1: "Room Type:",
    ROOMINFO: "Room Information",
    BEDNUM: "Double Room",
    NEGOTIATEDHOTEL: "Negotiated Hotel",
    NEGOTIATEDHOTELTRUECP: "Company Preferred Hotel",
    NEGOTIATEDHOTELTRUEAP: "CWT Preferred Hotel",
    NEGOTIATEDHOTELFALSE: "Non Negotiated Hotel",
    NEGOTIATEDPRICE: "Negotiated Price",
    NEGOTIATEDPRICE0: "Negotiated Price",
    NEGOTIATEDPRICE1: "Non Negotiated Price",
    INPOLICY: "In Policy",
    INPOLICYFALSE: "Out Of Policy",
    INPOLICYTRUE: "In Policy",
    SERVICETEAM: "Service Team",
    NONSMOKING: "Non-smoking room",
    MIINFO: "Custom",
    ISMANUALORDER: "Manual Order:",
    MANUALORDER: "Yes",
    NOTMANUALORDER: "No",
    UPDATEORDERDIALOG: "Update Order Information",
    ORDERSTATUSNAME: "Order Status",
    ORDERSTATUSRULES: "Please select order status",
    VALIDATESTATUSTIPS:
      "Consistent with the current order status, please re select",
    ORDERCANCLESUCCESS: "The order has been cancelled successfully!",
    ORDERCANCLEFAILED: "Failed to cancel the order!",
    BURCANCLETIPS:
      "This order is a delayed confirmation Hotel and needs to be cancelled during the normal working hours of the service group. For urgent assistance, please call service team.",
    BURHOTELCONFIRMNO: "Hotel confirmation number",
    BURCANCLEREMARK: "Remark",
    ORDERUPDATESUCCESS: "Order modification successfully!",
    ORDERCONFIRMSUCCESS: "Order confirmed successfully!",
    ORDERREJECTSUCCESS: "Order rejected successfully!",
    GUARANTEETYPE: "Guarantee:",
    GUARANTEETYPE1: "All Guarantee",
    GUARANTEETYPE2: "First Night Guarantee",
    GUARANTEETYPE3: "No Guarantee Required",
    GUARANTEETYPE4: "Guaranteed",
    GUARANTEETYPE5: "Deposit",
    CRMCONFIRMATIONNO: "HotelConfirmationNo:",
    CRMSOURCE: "Source:",
    CRMPNR: "PNR:",
    CONFIRMBTNUPDATE: "Confirm modification",
    CANCELBTNUPDATE: "Cancel modification",
    EMERGENCY: "Emergency Service Fee:",
    ADVANCEPAYMENT: "Advance Charges:",
    CARDSWIPEFEE: "Card Swipe Fee:",
    BACK: "Back",
    BTNCONFIRMPAY: "Confirm Payment",
    SYNC:"Sync",
    Edit:"Edit",
    PAYMENTSTATUSPRETIPS:"Please finish payment within 15mins. Afterwards order will be failed booking!",
    BEDTYPECN:"Room Type CN",
    BEDTYPEEN:"Room Type EN",
    ORDERMODIFYFAILED:"Failed to modify order",
    CCTITLE:"using comma “,” between email addresses",
    PREPAYREMARK:"Please contact service team within three days after checkout in case of any refunding request.",
    PAYBUTTON:"Go to pay",
    SubmitApproval:"Submit Approval",
    BeijingTime:"[Beijing Time]",
    LocalTime:"[Local Time]",
  },
  MAPRESULT: {
    MAPPAGE: "Map Page",
    RRICE: "Price",
    STARRATING: "Star Rating",
    DISTANCE: "Distance",
    SHOWONLIST: "Show on List",
    TEL: "TEL:",
    ADDRESS: "Address:",
    VirtualGuarantee:"Virtual Card Guarantee",
  },
  DESTINATION: {
    INHOTCITY: "Popular domestic cities",
    OUTHOTCITY: "Popular overseas cities",
    HOTCITY: "Popular cities",
    NOTDEST: "Destination information was not queried",
    SEARCHPL: "Please enter search keywords",
    CLOSEPOP: "Close",
    WAITSEARCHTIP: "Please wait, retrieving...",
    SEARCHRECORDS: "Recent Searches",
    CLEARHISTORY: "Clear History",
  },
  GUARANTEE: {
    //TEMP
    ROOMTYPE1: "KING BED GUEST ROOM(Big Bed)",
    ROOMDESCRIPTION: "Located on the {floor}",
    BANK1: "PBC",
    BANK2: "ABC",
    BANK3: "ICBC",
    BANK4: "CCB",
    INPUTCARDHOLDER: "Sample: Li Meimei",
    ADDNEWCARD: "USE NEW CARD",
    CONFIRMBOOKING: "CONFIRM BOOKING",
    REMINDER: "Please review the booking details in below:",
    SUPPORTCREDITCARD: "Support Credit Card:",
    ROOMTYPE: "Room Type:",
    // BREAKFAST:"Breakfast:",
    ISSUEBANK: "Issuing Bank:",
    SAVECARDINFOMATION: "Save Card Information",
    CHECKINDATE: "Check-In Date:",
    CHECKOUTDATE: "Check-Out Date:",
    ROOMNUMBER_PREFIX: "Total Night(s):",
    ROOMNUMBER_SUFFIX: "",
    TOTALAMOUNT: "Total Amount:",
    NIGHTS_PREFIX: "Number of Room(s):",
    NIGHTS_SUFFIX: "",
    SELECTHOTEL: "Hotel Results Page",
    CONFIRMATION: "Booking Confirmation Page",
    GUARANTEE: "Booking Payment Page",
    NAMEOFCARDHOLDER: "Cardholder Name:",
    IDTYPE: "ID Type:",
    CREDITCARDTYPE: "Card Type:",
    PERIODOFVALIDITY: "Card Expiration Date:",
    MOBILEPHONE: "Mobile:",
    IDNUMBER: "ID Number:",
    CARDNUMBER: "Credit Card:",
    BREAKFAST: "Breakfast x {num}",
    BREAKFAST1: "Breakfast:",
    RULECREDITTYPE: "Please select a credit card type",
    RULECREDITVIL: "Please enter the correct credit card number",
    RULECREDITCARD: "Credit card number not filled in",
    RULECARDNAME: "Please provide cardholder's name",
    RULEVALIDITYDATE: "Please provide validity period",
    RULEVALIDITYDATE2: "Please enter the valid period correctly",
    RULEVALIDITYDATE3: "not valid time",
    RULEIDTYPE: "Please enter the correct ID number",
    NAME: "Guest Name:",
    TEL: "Guest Mobile:",
    EMAIL: "Guest Email:",
    CARDNAMEVALIDATE: "Incorrect name. Please fill in English letter and one space to split first name and last name, eg. 'Zhang Sanqiang'.",
    CARDNAMEVALIDATECHINA: "Incorrect card holder name, please fill in Chinese",
    CARDTYPETIPS: "Incorrect card type, please change another credit card",
    CARDNOMSG: "No qualified credit card is available",
    CARDNULLMSG: "Card information unavailable",
    ISFIRST: "Is Default",
    CARDPROPERTY: "Card properties:",
    CARDPROPERTYCOM: "Company",
    CARDPROPERTYPER: "Personal",
    RULECARDTYPE: "No certificate type selected",
    RULECARDNUM: "Certificate No. is not filled in",
    RULECHINESENAME: "Please input Chinese name",
    RULECODE: "Please input code",
    RULECHINESECVV: "Please input CVV code",
    SMSCODE: "Send code",
    SMSCODEREST: "s Resend it",
    CancelPay: "CANCEL PAYMENT",
  },
  GUESTSCOMPONENTS: {
    ROOM: "Room",
    ADULT: "Adult",
    ROOMNUM: "Rooms",
    ADULTNUM: "Adults",
  },
  USERDIALOG: {
    TABNAEM1: "Employee List",
    TABNAEM2: "Guest",
    BTNGUEST: "Add Guests",
    GUEST: "Guests",
    TABLENAME: "Name",
    TABLETEL: "Tel",
    NAME: "Name:",
    TEL: "Mobile:",
    SEARCHTEL: "Tel",
    SEARCHNAME: "Name",
    TABLEEMPLOYEEID: "Employee ID",
    DEPARTMENT: "Department",
    OPERATION: "Operation",
    SELECT: "Select",
    IDNUMBER: "ID Number",
    BTNSEARCH: "Search",
    EMAIL: "Email:",
    SEARCHEMAIL: "Email",
    GUESTNAME: "Please enter valid name",
    GUESTMOBILE: "Please enter contact information",
    GUESTEMAIL: "Please provide the correct email",
    GUESTEMAIL2: "Please enter the correct email address",
    TRAVELERTITLE: "Trip Travelers",
  },
  PRICEDIALOG: {
    TITLE: "Price Detail",
    DATE: "Date",
    PRICE: "Price(tax incl.)",
    TAXSTATE: "Tax State:Tax charge is subject to hotal",
    TAX: "Tax",
    FEE: "Other",
  },
  MANUAL: {
    TAX: "Tax:",
    OTHERS: "Others:",
    ADVANCEPAYMENT: "Advance Charges:({Type})",
    ORDERMANAGE: "Order Management",
    MANUALORDER: "Manual Order Page",
    SELECTGUEST: "Guest Information",
    CLIENTLIST: "Client List",
    CLIENT: "Client Name",
    SEARCHCLIENTNO: "Client No.",
    SEARCHCLIENT: "Client Name",
    CONTACTNAME: "Contact Name",
    PROCESSORS: "Processors",
    CONTACTMOBILE: "Contact Mobile",
    CONTACTEMAIL: "Contact Email",
    GUESTNAME: "Guest Name",
    MOBILE: "Mobile",
    EMAIL: "Email",
    APPROVEDTRIPS: "Approved Trips",
    ORDERINFO: "Order Information",
    HOTELNO: "Hotel Confirm No.",
    ORDERSTATUS: "Order Status",
    CITY: "City",
    CHECKIN: "Check-In Date",
    CHECKOUT: "Check-Out Date",
    PAYMENTSTATUS: "Payment Status",
    SETTLEMENT: "Settlement Method",
    PRICETYPE: "Price Type",
    RATEACCESSCODE: "Rate Access Code",
    SERVICEFREE: "Service Fee:",
    URGENTFEE: "Emergency Service Fee",
    SUPPILENO: "Suppiler Order No.",
    REMARK: "Remark",
    HOTELINFO: "Hotel Information",
    HOTELIST: "Hotel List",
    HOTELNAME: "Hotel Name",
    SEACHHOTELNAME: "Hotel Name",
    HOTELNAMECN: "Hotel Name In Chinese",
    HOTELNAMEEN: "Hotel Name In English",
    FXID: "FX ID",
    STARRATING: "star Rating",
    SEACHSTARRATING: "star Rating",
    TELFAX: "Tel/Fax",
    CONTACTTEL: "Contact Tel",
    HOTELADDRESS: "Address",
    ADDRESS: "Address",
    HOTELTYPE: "Hotel Type",
    BREAKFAST: "Breakfast",
    ROOMTYPE: "Room Type",
    SMORKING: "Smorking",
    MONERARTUNIT: "Monetary Unit",
    TOTAL: "Total Amount(tax incl.)",
    PRICEDETAILS: "Price Details",
    PRICEDETAILSDATE: "Date",
    PRICEDETAILSPRICE: "Price(tax incl.)",
    FILLINTHEDETAILEDDAILYPRICE: "Input Daily Price",
    MANAGEMENTINFORMATION: "Management Information",
    CHANNEL: "Channel",
    CHANNELDIALOGTITLE: "Channel",
    CONTRACT: "Contact Information",
    CONTRACTNAME: "Contact Name",
    POLICYINFO: "Policy Information",
    GUARANTEE1: "Guarantee",
    CANCELLATION: "Canncellation Policy",
    TOTALTAXES: "Total taxes",
    TOTALFEES: "Total fees",
    BTNSUBMIT: "SUBMIT",
    VALIDATEAPPROVEDTRIPANDCITY:
      "The city you selected does not match the city of the travel slip. Please confirm whether the associated travel slip is correct?",
    VALIDATECANCELDATETIPS:
      "Time limited cancellation the selected date does not comply with the time limited unsubscribe rule",
    ORDERCREATEDSUCCESSFULLYTIPS: "Order Created Successfully,Order number is ",
    ORDERCREATEDFAILEDTIPS: "Order Created Failed,",
    ORDERCREATEDEXCEPTIONTIPS: "Order Created Exception,",
    SELECTPLACEHOLDER: "Please select",
    SELECTPDEADLINEDATE: "Please Select Cancellation Date With Time Limit",
    SELECTPDEADLINETIME: "Please Select Cancellation Time With Time Limit",
    APPROVEDTRIPSLIST: "Travel List",
    SYSTEMAPPROVEDTRIPSNO: "System Travel No",
    CUSTOMERAPPROVEDTRIPSNO: "Client Travel No",
    APPROVEDTRIPSERPERSONNEL: "Traveler User",
    APPROVEDTRIPSLOCATION: "Travel Location",
    APPROVEDTRIPSREASON: "Travel Reason",
    APPROVEDTRIPSDate: "Travel Time",
    VALIDATECUSTOMERNAME: "Please Enter Client Name",
    VALIDATECONTACTNAME: "Please Enter Contact Name",
    VALIDATECONTACTMOBILE: "Please Enter Contact Mobile",
    VALIDATECONTACTEMAIL: "Please Enter Contact Email",
    VALIDATETRAVELERNAME: "Please Enter Guest Name",
    VALIDATEMOBILE: "Please Enter Mobile",
    VALIDATEPHONEFORMAT: "Please Enter the correct phone number",
    VALIDATEEMAIL: "Please Enter Email",
    VALIDATECITYNAME: "Please Enter City",
    VALIDATEORDERSTATUS: "Please Enter Order Status",
    VALIDATECHECKINDATE: "Please Enter Check-In Date",
    VALIDATECHECKOUTDATE: "Please Enter Check-Out Date",
    VALIDATECHECKOUTDATEANDINDATE:
      "Please confirm that the check-out time is later than the check-in time",
    VALIDATEPAYMENTSTATUS: "Please Enter Payment Status",
    VALIDATESETTLEMENTMETHOD: "Please Enter Settlement Method",
    VALIDATEPRICETYPE: "Please Enter Price Type",
    VALIDATEHOTELNAME: "Please Enter Hotel Name",
    VALIDATEROOMTYPENAME: "Please Enter Room Type",
    VALIDATEBREAKFAST: "Please Enter Breakfast",
    VALIDATEHOTELTYPE: "Please Enter Hotel Type",
    VALIDATESERVICEFEE: "Please Enter Service Fee",
    VALIDATEURGENTFEE: "Please Enter Urgent Fee",
    VALIDATECHANNEL: "Please Enter Channel",
    VALIDATECHANNELOTHER: "Please Enter Other Channel",
    VALIDATECURRENCYCODE: "Please Enter Monetary Unit",
    // VALIDATETOTALPRICE: "Please Enter Total Amount",
    VALIDATETOTALPRICE:
      "Please Enter Input The Daily Price On The Right Completely",
    VALIDATEDAILYPRICES: "Please Enter Input Daily Price",
    VALIDATEGUARANTEETYPE: "Please Enter Guarantee",
    VALIDATECANCELLATIONPOLICY: "Please Enter Canncellation Policy",
    VALIDATECANCELDATEONPOLICY:
      "Please Enter Cancellation Date And Time With  Time Limit",
    VALIDATEADVANCEPAYMENT: "Please Enter advancepayment",
    // temp option
    ORDERSTATUSOPTION: [
      { label: "Booked", value: "BOOKED" },
      { label: "Booking_Failed", value: "BOOKING_FAILED" }
    ],
    PAYMENTSTATUSOPTION: [
      { label: "Pay at hotel", value: "0" },
      { label: "Pay at hotel (Guaranteed)", value: "1" },
      { label: "Prepay (paid)", value: "2" },
      { label: "Prepay (unpaid)", value: "3" },
      { label: "CompanyPay", value: "4" },
    ],
    SETTLEMENTOPTION: [
      { label: "Pay at hotel", value: "1" },
      { label: "Prepay", value: "2" },
      { label: "CompanyPay", value: "3" },
    ],
    PRICETYPEOPTION: [
      { label: "CWT negociated price", value: "2" },
      { label: "Company Negotiated Price", value: "3" },
      { label: "Public price", value: "1" },
    ],
    HOTELTYPEOPTION: [
      { label: "CWT negociated hotel", value: "1" },
      { label: "Company Preferred hotel", value: "2" },
      { label: "Public hotel", value: "3" },
    ],
    BREAKFASTOPTION: [
      { label: "Breakfast", value: "99" },
      { label: "No Breakfast", value: "0" },
      { label: "Unknown", value: "100" },
    ],
    SMORKINGOPTION: [
      { label: "No smoke", value: "N" },
      { label: "Smoke", value: "Y" },
      { label: "Unknown", value: "U" },
    ],
    CHANNELOPTION: [
      { label: "sabre", value: "sabre" },
      { label: "booking", value: "booking" },
      { label: "酒店官网", value: "酒店官网" },
      { label: "酒店电话中心", value: "酒店电话中心" },
      { label: "直接拨打酒店", value: "直接拨打酒店" },
      { label: "atour", value: "atour" },
      { label: "wehotel", value: "wehotel" },
      { label: "其他", value: "-1" },
    ],
    GUARANTEE1OPTION: [
      { label: "Full Guarantee", value: "1" },
      { label: "First Night Guarantee", value: "2" },
      { label: "Non-guarantee", value: "3" },
    ],
    CANCELLATIONOPTION: [
      { label: "Non-refundable", value: "0" },
      { label: "Free cancellation before certain time", value: "2" },
      { label: "Free cancellation", value: "1" },
    ],
    DEADLINETIMEOPTION: [
      { label: "00:00", value: "0" },
      { label: "01:00", value: "1" },
      { label: "02:00", value: "2" },
      { label: "03:00", value: "3" },
      { label: "04:00", value: "4" },
      { label: "05:00", value: "5" },
      { label: "06:00", value: "6" },
      { label: "07:00", value: "7" },
      { label: "08:00", value: "8" },
      { label: "09:00", value: "9" },
      { label: "10:00", value: "10" },
      { label: "11:00", value: "11" },
      { label: "12:00", value: "12" },
      { label: "13:00", value: "13" },
      { label: "14:00", value: "14" },
      { label: "15:00", value: "15" },
      { label: "16:00", value: "16" },
      { label: "17:00", value: "17" },
      { label: "18:00", value: "18" },
      { label: "19:00", value: "19" },
      { label: "20:00", value: "20" },
      { label: "21:00", value: "21" },
      { label: "22:00", value: "22" },
      { label: "23:00", value: "23" },
    ],
    APPROVEDTRIPSTYPEOPTION: [
      { label: "System Travel No", value: "1" },
      { label: "Client Travel No", value: "2" },
    ],
    STARTRATINGOPTION: [
      { label: "2 stars and below", value: "2" },
      { label: "3 Stars", value: "3" },
      { label: "4 Stars", value: "4" },
      { label: "5 Stars and above", value: "5" },
    ],
  },
  MYORDER: {
    Client: "Client",
    Department: "Department",
    Traveler: "Guest",
    OtherTraveler: "OtherGuest",
    Destination: "Destination",
    HotelName: "Hotel Name",
    DateType: "Date Type",
    BookingDate: "Booking Date",
    CheckInDate: "CheckIn Date",
    StartDate: "Start Date",
    EndDate: "End Date",
    OrderNo: "Order No.",
    OrderStatus: "Order Status",
    PaymentType: "Payment Type",
    Search: "Search",
    GuaranteePolicy: "Guarantee Policy",
    RESPONSEDATA: {
      city: "en",
    },
  },
  ORDERLIST: {
    RESPONSEDATA: {
      hotelName: "en",
    },
    WARNING: "Please select Date Type",
    Client: "Client",
    OrderNo: "Order No.",
    Traveler: "Guest",
    City: "City",
    HotelName: "Hotel Name",
    BookingDate: "Booking Date",
    CheckInDate: "CheckIn Date",
    CheckOutDate: "CheckOut Date",
    ActualCheckInDate: "Actual CheckIn Date",
    ActualCheckOutDate: "Actual CheckOut Date",
    PaymentType: "Payment Type",
    PaymentAmount: "Order Amount", //"Payment Amount",
    OrderStatus: "Order Status",
    APPROVALSTATUS: "Approval Status:",
    ManualOrder: "Manual Order",
    IsManualOrder: "Yes",
    IsnotManualOrder: "No",
    Operation: "Operation",
    Detail: "Detail",
    DELETE: "Delete",
    NoData:
      "Sorry, there is no qualified orders. Please check the conditions, and then try again.",
    CONFIRMCHECK: "Please choose the start date and end date",
    TIMECHECK: "Please ensure the End Date is not early than the Start Date",
    //temp
    TABLEVAL1: "H_21090878",
    TABLEVAL2: "Liu/Zhong",
    TABLEVAL3: "Shanghai",
    TABLEVAL4: "Jimuxiaozhu",
    TABLEVAL6: "Pay at Hotel",
    TABLEVAL8: "Confirmed",
    EAPORTEXCEL: "Export Excel",
  },
  ORDERINFO: {
    LinkName: "Order Management",
    PageTite: "Order List Page",
    MyOrderTitle: "My Order",
    DepartmentOrderTitle: "Department Order",
    HotelOrderTitle: "Hotel Order",
    ManualOrderTitle: "Manual Order",
  },
  OPTIONS: {
    BOOKINGSUCCESS: "Booking Success",
    CancelBOOKINGSUCCESS: "Cancel Booking Success",
    PAYMENTSTATUSAll: "All",
    PAYMENTSTATUSHotel: "Pay at Hotel",
    PAYMENTSTATUSPublic: "Business Pay",
    PAYMENTSTATUSpre: "Online Pay",
    OrderSUCCESS: "Booked",
    OrderCancel: "Cancelled",
    OrderLeave: "Check Out",
    OrderPaymentStatus: "No Show",
    OrderPendingStatus: "Pending Confirmation",
    PENDINGBOOKING: "Pending Booking",
    PENDINPROCESSED: "Pending Confirmation",
    PENDINGCANCEL: "Pending Cancellation",
  },
  COMMONPARAM: {
    // 后台中英文固定格式
    RESPONSEDATA: {
      SHOWTYPE: "en",
    },
    WINDOW: {
      WINDOW0: "No Windows",
      WINDOW1: "Windows",
      WINDOW2: "Some has window",
      WINDOW3: "Inner Windows",
      WINDOW4: "Skylights",
      WINDOW5: "Closed Window",
      WINDOW6: "Bay Window",
    },
    WIFI: {
      WIFI0: "No Internet",
      WIFI1: "Free WIFI",
      WIFI2: "Some rooms have free WIFI",
      WIFI3: "Paid WIFI",
      WIFI4: "Some rooms have paid WIFI",
    },
    PAYMENTTYPE: {
      PAYMENTTYPE4: "All",
      PAYMENTTYPE1: "Pay At Hotel",
      PAYMENTTYPE2: "Online Pay",
      PAYMENTTYPE3: "CompanyPay",
      PAYMENTTYPENAN: "Payment Type",
    },
    ORDERSTATE: {
      BOOKED: "Booked",
      PENDING_BOOKING: "Pending Booking",
      PENDING_CONFIRMATION: "Pending Confirmation",
      CANCELLED: "Cancelled",
      REFUNDED: "Refunded",
      CHECKOUT: "Check Out",
      NOSHOW: "No Show",
      CWT_PENDING_CANCELLATION: "Pending Cancellation",
      CWT_PENDING_CONFIRMATION: "Pending Confirmation",
      BOOKING_FAILED: "Booking Failed",
      CWT_PENDING_APPROVAL: "Awaiting Approval",
      CWT_PENDING_SUBMISSION: "Pending Submission"
    },
    APPROVALSTATUS: {
      0: "Pending Submission",
      1: "Pending Approval",
      2: "Approved",
      3: "Approval rejected",
      4: "Expired"
    },
    //防疫工具集地址
    NAV1URL: "https://obt.mycwt.com.cn/index-travel-en.aspx",
  },
  BIGORDER: {
    AddBigOrder: "Add Large Order",
    CreateBigOrder: "Create Large Order",
    Client: "Client Name",
    BigOrderNo: "Order Number",
    UserName: "Travelers",
    TotalPrice: "Price",
    CreateByName: "Creator",
    CreateTime: "CreationTime",
    OPERATION: "Operation",
  },
  HOTELORDEREMAIL: {
    APPROVEDINFO: "Itinerary Information",
    SUBSCRIBEREMAIL: "Booker:",
    CHECKINEMAIL: "To:",
    CHECKINEMAILTITLE: "check-in Guest‘s email",
    CCEMAIL: "CC Email:",
    REPEAT: "Send",
    REPEATMSG: "Re-sent Successfully!",
    ENNAME:"English",
    CNNAME:"Chinese",
  },
  EGuarantee: {
    CardTypes: "The transition can only be guaranteed/paid by [UnionPay]!",
    DetailTIPMSG:"An advance deposit is required. Room fee are to be paid upon arrival. The deposit will be returned within 5 working days after check-out.",
    SabreDetailTIPMSG:"You will be charged a prepayment of the total price at any time.",
    SabreDetailTIPMSGDeposit:"for sabre deposit",
    AgreeAgreement:"Tick to consent data transfer.",
    GetGuestAuthorization:"Authorization",
  },
  BANNERINFO:{
    ADDBANNERMAINTAIN:"Add",
  },
  OTHERPRODUCT:{
    MSG: "We have more product(s) for your business trip",
  },
  CREDITCARD:{
	  BANKCODENAME: "Select the credit card",
    CREDITCARDTYPE: "Credit Card Type",
    CREDITCARDNAME: "Cardholder",
    CREDITCARDNO: "Card No",
    CARDTYPE: "ID Type",
    CARDID: "ID No",
    CREDITCARDDATE: "Card Expiration Date",
    MOBILEPHONE: "Mobile",
    CVV: "CVV",
    BANKNAME: "Issue Bank",
    SIGNING:"Authorized",
    UNSIGNING:"Unauthorized",
    CAPTCHA:"Verification Code",
    GETCAPTCHA:"Get Code",
    SAVECARDINFOMATION:"Save Card Information",
    PAYBUTTON:"Pay",
    COUNTDOWN:"s)",
    VALIDATECREDITCARDNAME: "Please input the cardholder's name.",
    VALIDATECREDITCARDNO: "Please input the Card No.",
    VALIDATECARDID: "Please input the ID No.",
    VALIDATECREDITCARDDATE: "Please input valid through month and year, such as 0522",
    VALIDATEMOBILEPHONE: "Please input the registered mobile No.",
    VALIDATEMSG:"Please input {Msg}",
  },
  PAYORDERPAGE:{
    Amount:"Amount:",
    QRCodeMsg_Ali:"Please scan QR code in Alipay",
    QRCodeMsg_Wechat:"Please scan QR code in Wechat",
    AddNewCard:"Add New Card",
    PaymentSolutions:"Payment Solutions",
    AddCreditCard:"Add Credit Card",
    EditCreditCard:"Edit Credit Card",
    CardAuthorization:"Card Authorization",
    AgreePay:"Agree & Pay",
    PaymentSucceeded:"Payment Succeeded",
    PaymentFailed:"Payment Failed",
    DeleteCreditCardFailed:"Delete Failed",
    PaymentAlert:"Have you finished the payment?",
    PaymentAlertYes:"Yes",
    PaymentAlertNo:"No",
    CTACheckMsg:"Cost center error, Please contact the CWT Service Team.",
  },
  REFUNDREQUESTINFO:{
    REFUNDBUTTON: "Apply for Fapiao",
    REFUNDTITLE:"Please confirm the order details.",
    CHECKINDATE:"Check-in Date:",
    CHECKOUTDATE:"Check-out Date:",
    ROOMCHARGE:"Room Fee:",
    FREE:"Service Fee:",
    REFUNDMSG:"Invoice issuance is available after confirming the order, meanwhile online refund and cancellation is not supportted!",
    CONFIRMED:"Confirm",
    REFUNDREQUESTTITLE:"Refund Application",
    ACTUALCHECKINDATE: "Actual Check-in Date:",
    ACTUALCHECKOUTDATE: "Actual Check-out Date:",
    REFUNDREQUESTAMOUNT:"Refund Amount:",
    REMARK:"Remarks:",
    SUBMIT:"Submit",
    REFUNDREQUESTMSG:"We need five(5) days process request. ",
    SHOWDATEPICKER:"No-show:",
    VALIDATEAMOUNT:"Please input the refund amount.",
    VALIDATEMAXAMOUNT:"Refund amount cannot exceed the booked amount.",
  },
  INVOICINGSTATUS:{
    INVOICINGSTATUS0: "Issue Fapiao",
    INVOICINGSTATUS1: "Fapiao in queue",
    INVOICINGSTATUS2: "Check Fapiao details",
  },
  REFUNDREQUESTBUTTONMSG:{
    REFUNDREQUEST0: "Refund Application",
    REFUNDREQUEST1: "Submitted",
    REFUNDREQUEST2: "Investigation",
    REFUNDREQUEST3: "Proceeded",
    REFUNDREQUEST4: "Refund declined",
    REFUNDREQUEST5: "Refund in process",
    REFUNDREQUEST6: "Refund completed",
  },
  INVOICINGINFO:{
    TOTALPRICE:"Room Charge",
    INVOICINGPRICE:"Invoiced amount",
    INVOICINGDETAIL:"incl. room charge {roomFees}, service fees {serviceFees}",
    INVOICINGTYPE: "Invoice Type",
    INVOICINGSERVICEFEES: "Service fee separated to invoice",
    INVOICIGSTITLE:"SellerName",
    SERVICEFEESINVOICINGTYPE: "Fapiao Type",
    INVOICINGCOMPANY: "中航嘉信商务旅行管理有限公司",
    INVOICINGCOMPANY1: "中航嘉信商务旅行管理有限公司上海分公司",
    TIPS:"Please contact our call center in case the inaccurate invoice amount.",
    TIPS1:"Please assure invoice info aligned with your Company's  Business license/Tax registration.",
    DELETEMSG:"Confirm deleting?",
    DEFAULT:"Default",
    SUBMITBUTTONTIP:"We have received your Fapiao application. E-Fapiao will be sent to your mailbox within five working days.  ",
    SUBMITTITLE:"Tip",
    PERSONALINVOICEHEADER:"Personal Invoice Header",
    CORPORATERETRIEVEDINVOICEHEADER:"Corporate Retrieved Invoice Header",
    INVOICINGDETAILINFO:{
      TITLE:"Fapiao",
      INSTRUCTION:"Fapiao instruction",
      INSTRUCTIONMSG:"Hereunder the Fapiao issuing instruction",
      HEADERTYPE:"Header Type",
      HEADER:"Purchaser Name",
      TAXREGISTERNUMBER:"Purchaser TaxCode",
      BANKNAME:"Accounting Bank",
      BANKNUMBER:"Bank Account No.",
      REGISTEREDADDRESS:"Registered Address",
      REGISTEREDPHONE:"Registered Phone No.",
      DETAIL:"Fapiao Items",
      DETAILMSG_LINE1: "Broker agency service room booking fee {totalPrice}",
      DETAILMSG_LINE2: "Broker agency service fee {serviceFees}",
      INPUTPLACEHOLDER:"Please input {MSG}",
      TAXREGISTERNUMBERPLACEHOLDER:"Please input unified tax payer ID",
      ValidateInputCharacters:"Maximum 100 characters or 50 Chinese characters",
      ValidateInputTaxNumber:"The tax number must be 7-20 digits of numbers or letters.",
      ValidateHeaderName:"The buyer and seller cannot be the same enterprise.",
    },
    CONTACTSINFO:{
      CONTACTSMSG:"Contacts",
      NAME:"Name",
      PHONE:"Mobile",
      EMAIL:"Email"
    }
  },
  H5INVOICINGINFO:{
    HEADERPLACEHOLDER:"Please select purchaser name",
    INVOICINGLISTTITLE:"Please select purchaser name",
    INVOICINGTYPETITLE:"Fapiao Type",
    INVOICINGCONTACTSTITLE:"Please select the contacts",
    INVOICINGTYPE_NORMALTIPS:"* Fapiao will be pushed to your email within four(4) working days.",
    CONTACTSTITLE:"Select the contacts",
    TIPS:"Maximum three records maintained",
    //INVOICINGTYPE_APPRECIATETIPS:"提交开票申请后"
  },
  INVOICINGTYPE:{
    NORMAL: "Regular VAT E-Fapiao",
    APPRECIATE: "Special VAT E-Fapiao",
  },
  INVOICINGHEADERTYPE:{
    CORPORATION:"Enterprise Regular VAT E-Fapiao",
    NOCORPORATION:"Enterprise Special VAT E-Fapiao",
    PERSONS:"Personal Regular VAT E-Fapiao"
  },
  INVOICINGBUTTON:{
    CHOSEHEADER:"Select Header",
    CHOSE:"Select",
    DEIT:"Modify",
    DELETE:"Delete",
    ISFIRST:"Save as default",
    SAVE:"Save",
    OPENISFIRST:"Activated",
    CLOSEISFIRST:"Deactivated",
    SUBMIT:"Submit",
    CANCEL:"Cancel",
    CONFIRM:"Confirm",
    RESENT:"Resend email Fapiao",
    ADDINVOICING:"Add New Header",
    CHOSECONTACTS:"Select Contacts",
    ADDCONTACTS:"Add Contacts"
  },
  PAYMENTTYPE:{
    PAYMENTTYPE:"Payment Method",
    KQ:"99Bill",
    Alipay:"Alipay",
    WeChatPay:"Wechat",
    CTA:"MasterCard-CTA",
  },
  HOTELGROUPINFO: {
    Hyatt:"Hyatt",
    Radisson:"Radisson",
    Ramada:"Ramada",
    Wyndham:"Wyndham",
    Marriott:"Marriott",
    Accor:"Accor",
    Raffles:"Raffles",
    Kempinski:"Kempinski",
    TheRitzCarlton:"The Ritz-Carlton",
    Hilton:"Hilton",
    ShangriLa:"Shangri-La",
    IHG:"IHG",
    Millennium:"Millennium",
    Rosewood:"Rosewood",
    Preferred:"Preferred",
    Wanda:"Wanda",
    HUAZHU:"HUAZHU",
    JinJiangInternational:"JinJiang International",
    JinjiangChina:"Jinjiang China",
    Dossen:"Dossen",
    DossenInternational:"Dossen International",
    Homeinns:"Homeinns",
    Ascott:"Ascott",
    Atour:"Atour",
    Banyantree:"Banyantree",
    Fraser:"Fraser",
    Jumeirah:"Jumeirah",
    Langham:"Langham",
    MandarinOriental:"Mandarin Oriental",
    MarcoPolo:"Marco Polo",
    NewCentury:"New Century",
    SSAW:"SSAW",
  },
  route: {
    Home: "Home",
    Result: "Result",
    Detail: "Detail",
    Booking: "Booking",
    Guarantee: "Guarantee",
    Confirmation: "Confirmation",
    MapResultMobile: "MapResultMobile",
    MapHotelListMobile: "MapHotelListMobile",
    GaodeMap: "GaodeMap",
    OrderList: "OrderList",
    EGuarantee: "EGuarantee",
    PayOrder: "PayOrder",
    Invoicing: "Invoicing",
    IncidentReport: "IncidentReport"
  },
  cardTypeDialog:{
    idNumber: "Id Number",
    title: "Edit Certificate Information",
    certificateType: 'Edit Id Type',
    certificateNumber: 'Certificate Number',
    lastName: 'Surname',
    firstName: 'Given names',
    name: 'Names',
    birthDate: 'Date of Birth',
    gender: 'Gender',
    expiryDate: 'Date of Expiry',
    nationality: 'Nationality',
    issuingCountry: 'Country of Issue',
    male: 'Male',
    female: 'Female',
    save: 'Save',
    cancel: 'Cancel',
  },
  cardTypes: {
    IdCard: "ID Card",
    Passport: "Passport",
    HomeReturnPermit: "Home Return Permit",
    TaiwanCard: "Mainland Travel Permit for Taiwan Residents",
    OfficerCard: "Military ID",
    HongKongAndMacaoPass: "Valid Exit-Entry Permit (EEP) to HK / Macau",
    TaiWanPass: "Mainland Residents Traveling to Taiwan Permit",
    HkAndMacauPass: "Hk/Macao/Taiwai ID",
    ForeignPermanentResidentCard: "Foreign Permanent Resident Card",
  },
  cardTypeRules: {
    IdCardEmpty:"Card Number cannot be empty!",
    IdCardInvalid:"Invalid ID card number length!",
    IdCardFormat:"Invalid ID number format!",
    NameEmpty:"Name can not be empty!",
    NameInvalid:"The name of the ID card must be written in Chinese, but not begin with “身份证”!",
    CardNumberInvalid:"Wrong Card Number!",
    SurnameEmpty:"Surname cannot be empty!",
    GivenNameEmpty:"Given names cannot be empty!",
    CertificateNameInvalid:"Certificate name must be in Chinese!",
    CertificateEngNameInvalid:"The surname of the certificate must be in English",
    birthDateInvalid:"Date of Birthday error!",
    expiryDateInvalid:"Expire date error!",
    genderInvalid:"Gender can not be empty!",
    notionalityInvalid:"Nationality can not be empty!",
    issuingCountryInvalid:"Issuing Country can not be empty!",
  }

};
